import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Switch,
  FormControlLabel
} from '@mui/material';
import { FormLayout } from '../../types/form';

// ============================================================================
// Interfaces
// ============================================================================
interface FieldEditorProps {
  field: FormLayout['layout_config']['fields'][0];
  onUpdate: (field: FormLayout['layout_config']['fields'][0]) => void;
  onClose: () => void;
  open: boolean;
}

// ============================================================================
// Component
// ============================================================================
export const FieldEditor: React.FC<FieldEditorProps> = ({
  field,
  onUpdate,
  onClose,
  open
}) => {
  const [editedField, setEditedField] = useState(field);

  const handleSave = () => {
    onUpdate(editedField);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edit Field</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="Label"
            value={editedField.label}
            onChange={(e) => setEditedField({ ...editedField, label: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Width (%)"
            type="number"
            value={editedField.width}
            onChange={(e) => setEditedField({ ...editedField, width: Number(e.target.value) })}
            inputProps={{ min: 1, max: 100 }}
            margin="normal"
          />
          <FormControlLabel
            control={
              <Switch
                checked={editedField.required}
                onChange={(e) => setEditedField({ ...editedField, required: e.target.checked })}
              />
            }
            label="Required"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
